'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _sliceInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/slice');
var _Array$from = require('@babel/runtime-corejs3/core-js-stable/array/from');
var _Symbol = require('@babel/runtime-corejs3/core-js-stable/symbol');
var _getIteratorMethod = require('@babel/runtime-corejs3/core-js/get-iterator-method');
var _Array$isArray = require('@babel/runtime-corejs3/core-js-stable/array/is-array');
var _classCallCheck = require('@babel/runtime-corejs3/helpers/classCallCheck');
var _createClass = require('@babel/runtime-corejs3/helpers/createClass');
var _JSON$stringify = require('@babel/runtime-corejs3/core-js-stable/json/stringify');
var _forEachInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/for-each');
require('../expression/index.js');
require('../utils/index.js');
var loadingMapping_model = require('./loading-mapping.model.js');
var loadToEntityLogic_model = require('./load-to-entity-logic.model.js');
var parseJson = require('../expression/parse-json.js');
var helperFunctions = require('../utils/helper-functions.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _sliceInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_sliceInstanceProperty);
var _Array$from__default = /*#__PURE__*/_interopDefaultLegacy(_Array$from);
var _Symbol__default = /*#__PURE__*/_interopDefaultLegacy(_Symbol);
var _getIteratorMethod__default = /*#__PURE__*/_interopDefaultLegacy(_getIteratorMethod);
var _Array$isArray__default = /*#__PURE__*/_interopDefaultLegacy(_Array$isArray);
var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _JSON$stringify__default = /*#__PURE__*/_interopDefaultLegacy(_JSON$stringify);
var _forEachInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_forEachInstanceProperty);

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof _Symbol__default["default"] && _getIteratorMethod__default["default"](r) || r["@@iterator"]; if (!t) { if (_Array$isArray__default["default"](r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { var _context3; if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = _sliceInstanceProperty__default["default"](_context3 = {}.toString.call(r)).call(_context3, 8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? _Array$from__default["default"](r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }

/**
 * Describes one load to vertex statement.
 * - vertexName: loading target vertex type
 * - usingClauses: the using clauses
 * - hasOptions: the loading job has options or not
 * - options: if the loading job has options, record the options as a string here
 * - mappingWidgets: the mapping widgets (UDF, Map, Tuple, etc) used in the loading statement
 * - mappings: the loading mapping of primary id and attributes. 1st one is primary id mapping
 * - style: records the positions (and other styles in the future) of data source, target and
 *          middle items like token functions, etc for rendering in rhs panel.
 * - usingClauses: the using clauses.
 * - dataSource: the data source.
 *
 * @export
 * @interface LoadToVertexData
 */

/**
 * Provides APIs to handle load to vertex related business logic.
 *
 * @export
 * @class LoadToVertexLogic
 */
var LoadToVertexLogic = /*#__PURE__*/function () {
  function LoadToVertexLogic() {
    _classCallCheck__default["default"](this, LoadToVertexLogic);
  }
  return _createClass__default["default"](LoadToVertexLogic, null, [{
    key: "clone",
    value:
    /**
     * Clone load to vertex data.
     *
     * @static
     * @param {LoadToVertexData} data
     * @returns {LoadToVertexData}
     * @memberof LoadToVertexLogic
     */
    function clone(data) {
      return JSON.parse(_JSON$stringify__default["default"](data));
    }

    /**
     * Load information from GSQL load to vertex json and database json into load to vertex data.
     * Should do validation check before invoking this function.
     *
     * @static
     * @param {GSQLLoadToVertexJson} gsqlLoadToVertexJson
     * @param {DBLoadingStatementStyle} loadingStatementStyle
     * @param {DataFieldSchema[]} dataSchema
     * @returns {LoadToVertexData}
     * @memberof LoadToVertexLogic
     */
  }, {
    key: "loadFromGSQLAndDB",
    value: function loadFromGSQLAndDB(gsqlLoadToVertexJson, loadingStatementStyle, dataSchema) {
      var loadToVertexData = {
        vertexName: gsqlLoadToVertexJson.TargetName,
        style: loadingStatementStyle,
        mappings: [],
        mappingWidgets: [],
        usingClauses: gsqlLoadToVertexJson.UsingClauses,
        dataSource: gsqlLoadToVertexJson.DataSource
      };
      var _iterator = _createForOfIteratorHelper(gsqlLoadToVertexJson.Mappings),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var oneColumnMapping = _step.value;
          loadingMapping_model.LoadingMappingLogic.loadMappingFromGSQLMappingJson(oneColumnMapping, loadToVertexData.mappings, loadToVertexData.mappingWidgets, dataSchema);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return loadToVertexData;
    }

    /**
     * Dump in-memory load-to-vertex object into GSQL load-to-vertex json and database style json.
     *
     * @static
     * @param {LoadToVertexData} loadToVertex
     * @param {DataFormat} dataFormat
     * @param {DataFieldSchema[]} dataSchema
     * @returns {[GSQLLoadToVertexJson, DBLoadingStatementStyle]}
     * @memberof LoadToVertexLogic
     */
  }, {
    key: "dumpToGSQLAndDB",
    value: function dumpToGSQLAndDB(loadToVertex, dataFormat, dataSchema) {
      var _context;
      // Init
      var gsqlLoadToVertex = {
        Type: 'Vertex',
        TargetName: loadToVertex.vertexName,
        DataSource: loadToVertex.dataSource,
        Mappings: [],
        UsingClauses: loadToVertex.usingClauses
      };

      // Collect where clause for gsql if it is defined.
      if (loadToVertex.style.whereClauseJson) {
        gsqlLoadToVertex.WhereClause = parseJson.parseExprJson(loadToVertex.style.whereClauseJson).toString();
      }

      // Collect loading mapping
      var tokenFunctionPositions = [];
      _forEachInstanceProperty__default["default"](_context = loadToVertex.mappings).call(_context, function (mapping) {
        loadingMapping_model.LoadingMappingLogic.dumpToGSQLLoadingMapping(gsqlLoadToVertex.Mappings, mapping, loadToVertex.mappingWidgets, loadToVertex.style, tokenFunctionPositions, dataFormat, dataSchema);
      });
      var loadingStyle = {
        sourcePosition: loadToVertex.style.sourcePosition,
        targetPosition: loadToVertex.style.targetPosition,
        middlePositions: tokenFunctionPositions
      };

      // Collect where clause styles if it is defined.
      if (loadToVertex.style.whereClauseJson) {
        loadingStyle.whereClauseJson = loadToVertex.style.whereClauseJson;
      }
      return [gsqlLoadToVertex, loadingStyle];
    }

    /**
     * Semantic check if the load to vertex statement has semantic errors.
     *
     * @static
     * @param {LoadToVertexData} loadToVertex
     * @param {string[]} header
     * @param {Graph} schema
     * @returns {{
     *     success: boolean,
     *     message: string
     *   }}
     * @memberof LoadToVertexLogic
     */
  }, {
    key: "semanticCheck",
    value: function semanticCheck(loadToVertex, header, schema) {
      var _context2;
      var found = false;
      var mappingNumber = 1;
      _forEachInstanceProperty__default["default"](_context2 = schema.vertexTypes).call(_context2, function (vertexType) {
        if (vertexType.name === loadToVertex.vertexName) {
          found = true;
          mappingNumber += vertexType.attributes.length;
        }
      });

      // 1. Vertex name not exist in schema
      if (!found) {
        return {
          success: false,
          message: "Vertex type \"".concat(loadToVertex.vertexName, "\" doesn't exist in graph schema.")
        };
      }

      // 2. Loading mapping must with same number as vertex attributes plus primary id
      if (loadToVertex.mappings.length !== mappingNumber) {
        return {
          success: false,
          message: "Data loading mapping number and vertex attribute number don't match."
        };
      }

      // 3. Primary id cannot be default
      if (loadToVertex.mappings[0].sourceType === loadingMapping_model.SourceType.Default) {
        return {
          success: false,
          message: 'Need to map data column to vertex primary id.'
        };
      }

      // Do common semantic checks same with loadToEdge
      return loadToEntityLogic_model.LoadToEntityLogic.semanticCheck(loadToVertex, header);
    }

    /**
     * Create one load-to-vertex statement.
     *
     * @static
     * @param {Vertex} vertex
     * @param {{[propName: string]: string}} usingClauses
     * @returns {LoadToVertexData}
     * @memberof LoadToVertexLogic
     */
  }, {
    key: "createLoadToVertex",
    value: function createLoadToVertex(vertex, usingClauses) {
      // For brand new load-to-vertex statement, set data mapping to primary id and
      // attributes all as 'Default'
      var mappings = [];
      for (var i = 0; i < vertex.attributes.length + 1; i++) {
        mappings.push({
          sourceType: loadingMapping_model.SourceType.Default
        });
      }
      // Construct the load-to-vertex statement
      return {
        vertexName: vertex.name,
        mappingWidgets: [],
        mappings: mappings,
        style: {
          sourcePosition: {
            x: 30,
            y: 300
          },
          targetPosition: {
            x: 650,
            y: 300
          },
          middlePositions: []
        },
        dataSource: {
          Type: 'FileVar',
          Value: helperFunctions.HelperFunctions.dataFileName
        },
        usingClauses: usingClauses
      };
    }
  }]);
}();

exports.LoadToVertexLogic = LoadToVertexLogic;
